import React from "react";
import { Flex, Box, Text, Avatar, Badge, useColorModeValue } from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { role as getRole } from "variables/veille";
import { useSession } from "contexts/SessionContext";
import EditNameButton from "components/EditNameButton";

// En-tête de profil propre et robuste (pas de chevauchement) : avatar + nom + rôle + e-mail,
// et des indicateurs à droite sous forme de pastilles. `stats` = [{ value, label }].
export default function ProfileHeader({ stats = [] }) {
  const textColor = useColorModeValue("gray.700", "white");
  const { profile, role } = useSession();
  const nom = (profile && (profile.full_name || profile.email)) || "";
  const roleLabel = (getRole(role) || { label: "Analyste" }).label;

  return (
    <Card mb="24px">
      <CardBody>
        <Flex direction={{ base: "column", md: "row" }} align={{ base: "flex-start", md: "center" }} justify="space-between" gap="20px" w="100%">
          {/* Identité */}
          <Flex align="center" gap="16px" minW="0">
            <Avatar src={(profile && profile.avatar_url) || undefined} name={nom} w="72px" h="72px" flexShrink={0} />
            <Box minW="0">
              <Flex align="center" gap="8px" wrap="wrap">
                <Text fontSize="lg" fontWeight="bold" color={textColor} noOfLines={1}>{nom}</Text>
                <Badge colorScheme="teal" borderRadius="8px">{roleLabel}</Badge>
                <EditNameButton />
              </Flex>
              <Text fontSize="sm" color="gray.500" noOfLines={1}>{profile && profile.email}</Text>
            </Box>
          </Flex>

          {/* Indicateurs */}
          <Flex gap="12px" flexShrink={0} wrap="wrap">
            {stats.map((s, i) => (
              <Box key={i} bg="gray.50" borderRadius="14px" px="20px" py="12px" textAlign="center" minW="86px">
                <Text fontSize="2xl" fontWeight="bold" color="teal.500" lineHeight="1.1">{s.value}</Text>
                <Text fontSize="xs" color="gray.500" mt="3px" whiteSpace="nowrap">{s.label}</Text>
              </Box>
            ))}
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  );
}
